import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-tryout-fee-this-month-income',
  templateUrl: './tryout-fee-this-month-income.component.html',
  styleUrls: ['./tryout-fee-this-month-income.component.css']
})
export class TryoutFeeThisMonthIncomeComponent implements OnInit {
  @Input() NoOfThisMonthIncome: string;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-fee-this-month-income/tryout-fee-this-month-income.component.ts